import { render, staticRenderFns } from "./StatementFooter.vue?vue&type=template&id=32544317&scoped=true&"
import script from "./StatementFooter.vue?vue&type=script&lang=js&"
export * from "./StatementFooter.vue?vue&type=script&lang=js&"
import style0 from "./StatementFooter.vue?vue&type=style&index=0&id=32544317&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32544317",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
